import { debitNoteConstants } from '../constants';

export function debitNoteReducers(state = {}, action) {
    const { 
        totalRequests = 0,
        collectiveErrorMsg = ""
    } = state;

    let collectiveErrorMsg_formatted = collectiveErrorMsg;

    switch (action.type) {
            
        // Get Debit Note List
        
        case debitNoteConstants.getDebitNoteList_request:
            return {
                ...state,
                getDebitNoteList_requesting: true, getDebitNoteList_status: false,
            }
        case debitNoteConstants.getDebitNoteList_success:
            return {
                ...state,
                getDebitNoteList_requesting: false, getDebitNoteList_status: true,
                debitNoteList: action.details.data,
                debitNoteListHeaders: action.details.headers,
            }
        case debitNoteConstants.getDebitNoteList_failure:
            return {
                ...state,
                getDebitNoteList_requesting: false, getDebitNoteList_status: false, 
            }

        // Get All Debit Note List
        
        case debitNoteConstants.getAllDebitNoteList_request:
            return {
                ...state,
                getAllDebitNoteList_requesting: true, getAllDebitNoteList_status: false,
            }
        case debitNoteConstants.getAllDebitNoteList_success:
            return {
                ...state,
                getAllDebitNoteList_requesting: false, getAllDebitNoteList_status: true,
                allDebitNoteList: action.details.data,
                allDebitNoteListHeaders: action.details.headers,
            }
        case debitNoteConstants.getAllDebitNoteList_failure:
            return {
                ...state,
                getAllDebitNoteList_requesting: false, getAllDebitNoteList_status: false, 
            }

        // Post Debit Note
        
        case debitNoteConstants.postDebitNote_request:
            if (totalRequests == 0) 
                collectiveErrorMsg_formatted = "";

            return {
                ...state,
                postDebitNote_requesting: true, postDebitNote_status: false,
                isDebitNoteRecordUpdatedSuccessfully: undefined,
                postDebitNote_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case debitNoteConstants.postDebitNote_success:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";

            if (action?.details?.data)
                collectiveErrorMsg_formatted += action?.details?.data;

            return {
                ...state,
                postDebitNote_requesting: (totalRequests > 1), postDebitNote_status: true,
                isDebitNoteRecordUpdatedSuccessfully: ((totalRequests - 1) == 0),
                postDebitNote_errorMsg: collectiveErrorMsg_formatted, // Need to figure a better and correct way
                totalRequests: (totalRequests - 1)
            }
        case debitNoteConstants.postDebitNote_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";

            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                postDebitNote_requesting: (totalRequests > 1), postDebitNote_status: false, 
                isDebitNoteRecordUpdatedSuccessfully: false,
                postDebitNote_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (totalRequests - 1)
            }

        // Knock Off Credit
        
        case debitNoteConstants.knockOffCredit_request:
            if (totalRequests == 0) 
                collectiveErrorMsg_formatted = "";

            return {
                ...state,
                knockOffCredit_requesting: true, knockOffCredit_status: false,
                isDebitNoteRecordUpdatedSuccessfully: undefined,
                knockOffCredit_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case debitNoteConstants.knockOffCredit_success:
            return {
                ...state,
                knockOffCredit_requesting: (totalRequests > 1), knockOffCredit_status: true,
                isDebitNoteRecordUpdatedSuccessfully: true,
                totalRequests: (totalRequests - 1)
            }
        case debitNoteConstants.knockOffCredit_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                knockOffCredit_requesting: (totalRequests > 1), knockOffCredit_status: false, 
                isDebitNoteRecordUpdatedSuccessfully: false,
                knockOffCredit_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (totalRequests - 1)
            }

        // Delete Debit Note
        
        case debitNoteConstants.deleteDebitNote_request:
            if (totalRequests == 0) 
            collectiveErrorMsg_formatted = "";
            
            return {
                ...state,
                deleteDebitNote_requesting: true, deleteDebitNote_status: false,
                isDebitNoteRecordUpdatedSuccessfully: undefined,
                deleteDebitNote_errorMsg: undefined,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: (!(action?.details?.isRetrying))? (totalRequests + 1): totalRequests
            }
        case debitNoteConstants.deleteDebitNote_success:
            return {
                ...state,
                deleteDebitNote_requesting: (totalRequests > 1), deleteDebitNote_status: true,
                isDebitNoteRecordUpdatedSuccessfully: true,
                totalRequests: totalRequests - 1
            }
        case debitNoteConstants.deleteDebitNote_failure:
            if (collectiveErrorMsg_formatted != "") collectiveErrorMsg_formatted += "\n";
            
            if (action?.error?.response?.data?.exceptionMessage)
                collectiveErrorMsg_formatted += action?.error?.response?.data?.exceptionMessage;

            return {
                ...state,
                deleteDebitNote_requesting: (totalRequests > 1), deleteDebitNote_status: false, 
                isDebitNoteRecordUpdatedSuccessfully: false,
                deleteDebitNote_errorMsg: collectiveErrorMsg_formatted,
                collectiveErrorMsg: collectiveErrorMsg_formatted,
                totalRequests: totalRequests - 1
            }

        default:
            return state;
    }
}